import { z } from "zod";
import { ValidationMethods } from "../utility/validationMethods";
var minimumNameLength = 2;
var noEmojiMessage = "Emoji characters are not allowed.";
export var userSignupSchema = z
    .object({
    firstName: z
        .string()
        .trim()
        .min(minimumNameLength, "First name must be at least ".concat(minimumNameLength, " characters."))
        .refine(function (value) { return ValidationMethods.isNotEmoji(value); }, noEmojiMessage)
        .refine(function (value) { return ValidationMethods.isValidName(value); }, "First name can only include letters, spaces, periods, apostrophes, and hyphens."),
    lastName: z
        .string()
        .trim()
        .min(minimumNameLength, "Last name must be at least ".concat(minimumNameLength, " characters."))
        .refine(function (value) { return ValidationMethods.isNotEmoji(value); }, noEmojiMessage)
        .refine(function (value) { return ValidationMethods.isValidName(value); }, "Last name can only include letters, spaces, periods, apostrophes, and hyphens."),
    email: z
        .string()
        .trim()
        .min(1, "Email is required.")
        .email("Enter a valid email address.")
        .refine(function (value) { return ValidationMethods.isNotEmoji(value); }, noEmojiMessage),
    confirmEmail: z
        .string()
        .trim()
        .min(1, "Please confirm your email.")
        .refine(function (value) { return ValidationMethods.isNotEmoji(value); }, noEmojiMessage),
    phone: z
        .string()
        .trim()
        .min(1, "Phone number is required.")
        .refine(function (value) { return ValidationMethods.isNotEmoji(value); }, noEmojiMessage)
        .refine(function (value) { return ValidationMethods.isValidPhoneNumber(value) && ValidationMethods.hasValidPhoneAreaCode(value); }, "Please enter a valid phone number."),
    password: z
        .string()
        .min(8, "Password must be at least 8 characters.")
        .refine(function (value) { return ValidationMethods.isNotEmoji(value); }, noEmojiMessage)
        .refine(function (value) { return ValidationMethods.containsUppercaseLetter(value); }, "Password must include at least one uppercase letter.")
        .refine(function (value) { return ValidationMethods.containsDigit(value); }, "Password must include at least one number.")
        .refine(function (value) { return ValidationMethods.containsSpecialCharacter(value); }, "Password must include at least one special character."),
    confirmPassword: z
        .string()
        .min(1, "Please confirm your password.")
        .refine(function (value) { return ValidationMethods.isNotEmoji(value); }, noEmojiMessage),
    useRewards: z.boolean(),
    hasMarketingOptIn: z.boolean(),
})
    .superRefine(function (value, context) {
    if (value.confirmEmail !== value.email) {
        context.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["confirmEmail"],
            message: "Email addresses must match.",
        });
    }
    if (value.confirmPassword !== value.password) {
        context.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["confirmPassword"],
            message: "Passwords must match.",
        });
    }
});
